/* eslint-disable arrow-body-style */
import { connect } from 'react-redux';
import ConfirmationModal from '../components/shared/ConfirmationModal/ConfirmationModal';
import { RootState } from '../stores';
import { confirmationModalActions } from '../stores/confirmationModal/confirmationModalActions';
import { getconfirmationModalIsOpen } from '../stores/confirmationModal/confirmationModalSelector';
import { formActions } from '../stores/form/formActions';

const mapStateToProps = (state: RootState) => {
  return {
    isOpen: getconfirmationModalIsOpen(state),
    confirmationModalData: state.formState.formData,
  };
};

const mapDispatchToProps = {
  confirmationModalClose: confirmationModalActions.close,
  confirmationModalDataSubmit: (formSData: any) => formActions.submited(formSData),
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
